import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=5d83b768&scoped=true"
import script from "./TagsList.vue?vue&type=script&lang=js"
export * from "./TagsList.vue?vue&type=script&lang=js"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=5d83b768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d83b768",
  null
  
)

export default component.exports